import { clientToWorld } from '../canvas/viewportRef.ts'
import { setLiveStroke, style } from '../editor.ts'
import { createPath } from '../scene/factory.ts'
import { addNodes, scene } from '../scene/store.ts'
import { startDrag } from '../util/drag.ts'
import { simplifyPoints } from '../util/simplify.ts'
import type { Tool } from './types.ts'

/** Simplification tolerance in screen pixels, converted to world units. */
const TOLERANCE_PX = 0.7

export const penTool: Tool = {
  cursor: 'crosshair',

  onPointerDown(ctx) {
    const points = [ctx.world.x, ctx.world.y]
    const stroke = style.inkColor
    const strokeWidth = style.inkWidth

    // The stroke is previewed outside the document, then committed once on
    // release — so the live path writes no history and the node count is stable.
    setLiveStroke({ points: [...points], stroke, strokeWidth })

    let frame = 0
    const flush = () => {
      frame = 0
      setLiveStroke({ points: [...points], stroke, strokeWidth })
    }

    startDrag({
      onMove(e) {
        // Coalesced events carry the full pointer history between frames, which
        // is what makes a fast stroke smooth rather than polygonal.
        const batchOfEvents = e.getCoalescedEvents?.() ?? []
        for (const ev of batchOfEvents.length > 0 ? batchOfEvents : [e]) {
          const p = clientToWorld(ev)
          points.push(p.x, p.y)
        }
        if (!frame) frame = requestAnimationFrame(flush)
      },

      onUp() {
        if (frame) cancelAnimationFrame(frame)
        setLiveStroke(null)
        const simplified = simplifyPoints(points, TOLERANCE_PX / scene.camera.z)
        if (simplified.length >= 4) {
          addNodes([createPath(simplified, stroke, strokeWidth)], 'Draw')
        }
      },

      onCancel() {
        if (frame) cancelAnimationFrame(frame)
        setLiveStroke(null)
      },
    })
  },
}
